/**
 * TKP-200 m.18 — onay açıkken süreç kutusundaki toplu ilgili kişi ekleme: toplu uç yalnız onay yetkilisine açık, bu yüzden aynı iş
 * düğüm başına tekil eklemeyle (taslağa düşer) yapılır. Düğümde zaten olan ilgili kişi atlanır (toplu ucun kuralıyla aynı).
 */
const sid = (v) => String((v && v._id) || v || "");

export const bulkDatasubjectDraftPlan = (nodes = [], rowsByNode = {}, datasubjects = []) => {
  const steps = [];
  for (const node of nodes) {
    const have = new Set((rowsByNode[sid(node)] || []).map((r) => sid(r.datasubject)));
    for (const ds of datasubjects) if (!have.has(sid(ds))) steps.push({ processData: { _id: sid(node) }, datasubject: ds });
  }
  return steps;
};
